import { render } from "./ConversationTranscript.vue?vue&type=template&id=679e5668&scoped=true"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=679e5668&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679e5668"]])

export default __exports__